// ABOUTME: Drag handle icon with 6 dots pattern for drag-and-drop indicators
// ABOUTME: Supports className, size variant, and color customization

interface DragHandleIconProps {
  className?: string
  /** Size variant: "sm" (12x16) or "md" (16x20) */
  size?: "sm" | "md"
  color?: string
}

export const DragHandleIcon = ({ className = "", size = "sm", color = "#9CA3AF" }: DragHandleIconProps) => {
  if (size === "md") {
    return (
      <svg
        width={16}
        height={20}
        viewBox="0 0 16 20"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="4"
          cy="3"
          r="1.5"
          fill={color}
        />
        <circle
          cx="12"
          cy="3"
          r="1.5"
          fill={color}
        />
        <circle
          cx="4"
          cy="10"
          r="1.5"
          fill={color}
        />
        <circle
          cx="12"
          cy="10"
          r="1.5"
          fill={color}
        />
        <circle
          cx="4"
          cy="17"
          r="1.5"
          fill={color}
        />
        <circle
          cx="12"
          cy="17"
          r="1.5"
          fill={color}
        />
      </svg>
    )
  }

  return (
    <svg
      width={12}
      height={16}
      viewBox="0 0 12 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="2.5"
        cy="2.5"
        r="1.5"
        fill={color}
      />
      <circle
        cx="9.5"
        cy="2.5"
        r="1.5"
        fill={color}
      />
      <circle
        cx="2.5"
        cy="8"
        r="1.5"
        fill={color}
      />
      <circle
        cx="9.5"
        cy="8"
        r="1.5"
        fill={color}
      />
      <circle
        cx="2.5"
        cy="13.5"
        r="1.5"
        fill={color}
      />
      <circle
        cx="9.5"
        cy="13.5"
        r="1.5"
        fill={color}
      />
    </svg>
  )
}
